module.exports = __webpack_public_path__ + "media/images/footer/en_efs-67ff3808a4753e92f71d493ecafad960.svg";